const {
  canAccessDocumentAnalyzer,
  canSeeDocumentAnalyzer,
} = require('./canAccessDocumentAnalyzer');
const hasFeatureFlag = require('./hasFeatureFlag');

/**
 * Check if the user can access the DA compare documents feature
 * @param {Boolean} isExpired - true if the user is expired
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Array<string>} featureFlags - list of feature flags for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canAccessDocumentsComparison = (
  isExpired,
  plan,
  payingOptions,
  featureFlags,
  isLoggedIn,
) => {
  return (
    canAccessDocumentAnalyzer(isExpired, plan, payingOptions, isLoggedIn) &&
    hasFeatureFlag(featureFlags, 'compare_documents')
  );
};

/**
 * Check if the user can see the DA compare documents feature
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Array<string>} featureFlags - list of feature flags for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canSeeDocumentsComparison = (
  plan,
  payingOptions,
  featureFlags,
  isLoggedIn,
) => {
  return (
    canSeeDocumentAnalyzer(plan, payingOptions, isLoggedIn) &&
    hasFeatureFlag(featureFlags, 'compare_documents')
  );
};

module.exports = {
  canAccessDocumentsComparison,
  canSeeDocumentsComparison,
};
